// extracted by mini-css-extract-plugin
export default {"root":"o4pNYg9qgP"};